import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A module that third party code can modify.`}</p>
    <p>{`When Webpack loads a module into its bundles, it processes the source code
through a set of rules generated by Buildpack. A TargetableModule is a reference
to that source file, meant to be passed to interceptors. Inside
interceptors, extensions and projects can configure the TargetableModule to
transform it in many ways.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#TargetableModule"
        }}>{`TargetableModule`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#new_TargetableModule_new"
            }}>{`new TargetableModule(file, trackingOwner)`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableModule+addTransform"
            }}>{`.addTransform(type, transformModule, options)`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableModule+flush"
            }}>{`.flush()`}</a>{` ⇒ `}<inlineCode parentName="li">{`Array.<TransformRequest>`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableModule+insertAfterSource"
            }}>{`.insertAfterSource(after, insert, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableModule+insertBeforeSource"
            }}>{`.insertBeforeSource(before, insert, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableModule+prependSource"
            }}>{`.prependSource(insert)`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableModule+spliceSource"
            }}>{`.spliceSource(instruction)`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`Create a TargetableModule representing a file.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`file`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to the underlying source file.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingOwner`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Trackable`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Parent object for debugging purposes.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Add a transform request to this module's queue. The `}<inlineCode parentName="p">{`fileToTransform`}</inlineCode>{` of
the transform request is automatically set to this module's filename.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`TransformType`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Transform type`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transformModule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The Node module that runs the transform, such as a Webpack loader for type `}<inlineCode parentName="td">{`source`}</inlineCode>{` or a Babel plugin for type `}<inlineCode parentName="td">{`babel`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Configuration object to send to the transformModule.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Empty this module's queue of transforms, returning them as an array.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`Array.<TransformRequest>`}</inlineCode>{`
— An array of Transform requests.`}</p>
    <p>{`Insert text into the module contents, immediately following the location
of the search string if it is found.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`after`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text string in the module code to place the new content after.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`insert`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text to insert after the search string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Additional loader options.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.remove]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of characters to delete forward, after the search string.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Insert text into the module contents, immediately before the location
of the search string if it is found.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`before`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text string in the module code to place the new content before.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`insert`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text to insert before the search string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Additional loader options.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.remove]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of characters to delete forward, after the search string.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Add text to the beginning of a file.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`insert`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text to insert up top`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Do any splice operation supported by `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/loaders/splice-source-loader.js"
      }}>{`splice-source-loader`}</a>{`.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`instruction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Splice instruction.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableModule.js"
      }}>{`pwa-studio/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableModule.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      